import PropTypes from "prop-types"
import React from "react"

import searchIcon from "../../../../assets/Hub_Icons/search.svg"

export const PrimaryButton = ({ title, handler, type, className ,disable = false, searchIconButton }) => {
    const PRIMARY_CLASS = `${className} bg-white text-primary-50 border border-solid 
    hover:border-primary-150 hover:bg-primary-150 border-primary-50 font-bold 
    text-base px-6 py-3 rounded-full disabled:bg-primary-300 
    disabled:text-secondary-50 disabled:border-0`
    return (
        <button onClick={ (e) => handler(e) } type={ type } className={ PRIMARY_CLASS } disabled={ disable }>
            { searchIconButton && <span className="flex mr-1"><img alt="search" src={ searchIcon } className="" height={ "12px" } width={ "12px" } /></span> }
            {  title }
        </button>
    )
}
export const PrimaryButtonSmall = ({ title, handler, type, className, disable = false }) => {
    const PRIMARY_CLASS = `${className} bg-white text-sm text-primary-50 border 
    border-solid hover:border-primary-150 hover:bg-primary-150 border-primary-50 
    font-bold text-base h-9 px-4 rounded-full disabled:bg-primary-300 disabled:text-secondary-50 disabled:border-0`
    return (
        <button onClick={ (e) => handler(e) } type={ type } className={ PRIMARY_CLASS } disabled={ disable }>
            { title }
        </button>
    )
}

export const SecondaryButton = ({ title, handler, type, className, disable = false }) => {
    const SECONDARY_CLASS = `${className} text-white bg-primary-100 hover:bg-primary-150 
    hover:text-primary-50 font-bold text-base px-6 py-3 rounded-full mr-1 mb-1 disabled:bg-primary-300 disabled:text-secondary-50 disabled:border-0`

    return (
        <button onClick={ (e) => handler(e) } type={ type } className={ SECONDARY_CLASS } disabled={ disable }>
            { title }
        </button>
    )
}

export const SecondaryButtonSmall = ({ title, handler, type, className, disable = false }) => {
    const SECONDARY_CLASS = `${className} rounded-full bg-primary-100 text-white 
    font-bold text-sm  hover:bg-primary-150 hover:text-primary-50 h-9 px-4 disabled:bg-primary-300 
    disabled:text-secondary-50 disabled:border-0`

    return (
        <button onClick={ (e) => handler(e) } type={ type } className={ SECONDARY_CLASS } disabled={ disable }>
            { title }
        </button>
    )
}

export const TextButton = ({ handler, type }) => {
    return (
        <button
            onClick={ (e) => handler(e) }
            type={ type }
            className="text-primary-50 underline font-bold text-base px-6 py-3 
            outline-none focus:outline-none rounded-full"
        >
            Add Another Sales org
        </button>
    )
}

export const SearchButton = ({ className, handler, type, img }) => {
    return (
        <button
            onClick={ (e) => handler(e) }
            type={ type }
            className={ className }
        >
            <img src={ img } height={ "16px" } width={ "16px" } alt="filter" />
        </button>
    )
}

PrimaryButton.propTypes = {
    className: PropTypes.string,
    handler: PropTypes.any,
    title: PropTypes.string,
    type: PropTypes.any
}

PrimaryButtonSmall.propTypes = {
    className: PropTypes.string,
    handler: PropTypes.any,
    title: PropTypes.string,
    type: PropTypes.any
}

SecondaryButton.propTypes = {
    className: PropTypes.string,
    handler: PropTypes.any,
    title: PropTypes.string,
    type: PropTypes.any
}

SecondaryButtonSmall.propTypes = {
    className: PropTypes.string,
    handler: PropTypes.any,
    title: PropTypes.string,
    type: PropTypes.any
}

TextButton.propTypes = {
    handler: PropTypes.any,
    type: PropTypes.any
}

SearchButton.propTypes = {
    className: PropTypes.string,
    handler: PropTypes.any,
    img: PropTypes.string,
    type: PropTypes.any
}
